import { h } from 'preact'
import React from "preact/compat";
import store from "../store";
import * as actions from "../actions";
import MenuObject from '../canvas/menu-object';
import Renderer from '../canvas/renderer';
import util from '../util';
import MOBackIcon from "./svg/MOBackIcon";

const { dispatch } = store;
const { goToView, goToSubview, setSelectionType } = actions;

export default function AsideMenuObjectNav({ view, isVersionPreview, isMobileVersion, MOEditMode }) {
  function goTo(view, subview) {
    dispatch(goToView(view));
    if (subview) {
      dispatch(goToSubview(subview));
    }
    if (view === 'text-mo-edit') {
      if (isMobileVersion) {
        dispatch(goToSubview('items'));
      } else {
        dispatch(goToSubview('edit'));
      }
    } else if (view === 'text-mo-import') {
      dispatch(goToSubview('designs'));
    }

    if (view === 'text' || subview === 'add-new') {
      if (store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
        const $pages = $('#pages');
        const $menuObjects = $pages.find('.menu-object');
        util.deleteEmptyMenuObject($menuObjects);
      }

      //store.dispatch(actions.setSelectionType('text'));
      //store.dispatch(actions.showLayoutGuideBar(false));
      //store.dispatch(actions.deselect());
      //Renderer.deselectAll();
    }
  }

  return <header id="app-aside-menu-object-nav">
    <nav className="main menu-object-nav">
      <ul className={isVersionPreview ? 'hidden' : ''}>
        <li><a className={`link ${view === 'text-mo' || view === 'text-plain' ? ' active' : ''}`} onClick={() => goTo('text-mo', 'add-new')}>Text</a></li>

        <li><a className={`link ${view === 'text-mo-style' ? ' active' : ''}`} onClick={() => goTo('text-mo-style')}>Style</a></li>

        <li><a className={`link ${view === 'text-mo-spacing' ? ' active' : ''}`} onClick={() => goTo('text-mo-spacing')}>Spacing</a></li>

        <li><a className={`link ${view === 'text-mo-layout' ? ' active' : ''}`} onClick={() => goTo('text-mo-layout')}>Layout</a></li>

        {/*isMobileVersion && MOEditMode === 'name' &&
        <li><a className={`link ${view === 'text-mo-name-border' ? ' active' : ''}`} onClick={() => goTo('text-mo-name-border')}>Border</a></li>*/}

        {/*<li><a className={`link ${view === 'text-mo-import' ? ' active' : ''}`} onClick={() => goTo('text-mo-import')}>Import</a></li>*/}
      </ul>
    </nav>
  </header>
}
